import styled from 'styled-components/macro';

export const ServicesHolder = styled.div`
  /* display: flex; */
  justify-content: space-between;
  align-items: center;
  flex-flow: wrap;
`;
